import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import PreparationServices from "./Preparation.services";
import GeneralInfoServices from "../GeneralInfo/GeneralInfo.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getPreparation = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PREPARATION,
      payload: true,
    });
    const resp = await PreparationServices.getPreparation(filters);
    dispatch({
      type: actions.GET_PREPARATION,
      payload: {
        preparations: resp.data.data,
        preparationsLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.PREPARATION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.PREPARATION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PREPARATION,
      payload: false,
    });
  }
};

export const resetGeneralInfo = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PREPARATION,
      payload: true,
    });
    dispatch({
      type: actions.GET_PREPARATION,
      payload: {
        preparations: [],
        preparationsLength: 0,
      },
    });
    dispatch({
      type: actions.PREPARATION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.PREPARATION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PREPARATION,
      payload: false,
    });
  }
};

export const getPreparationById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PREPARATION_BY_ID,
      payload: true,
    });
    const resp = await PreparationServices.getPreparationById(id);
    dispatch({
      type: actions.GET_PREPARATION_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.PREPARATION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.PREPARATION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PREPARATION_BY_ID,
      payload: false,
    });
  }
};

export const savePreparation = (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_PREPARATION,
        payload: true,
      });
      const resp = await PreparationServices.savePreparation(data);
      const { preparations, preparationsLength } = getState().preparation;
      const _preparation = [...preparations, resp.data];
      dispatch({
        type: actions.GET_PREPARATION,
        payload: {
          preparations: _preparation,
          preparationsLength: preparationsLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL_PREPARATION,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_PREPARATION,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_PREPARATION,
        payload: false,
      });
    }
  };

export const editPreparation = (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_PREPARATION,
        payload: true,
      });
      const resp = await PreparationServices.editPreparation(id, data);
      const { preparations, preparationsLength } = getState().preparation;
      const dataT = resp.data;
      preparations[index] = dataT;
      dispatch({
        type: actions.GET_PREPARATION,
        payload: {
          preparations: preparations,
          preparationsLength: preparationsLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL_PREPARATION,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      const _data = {
        data:[
          {
            funcion_descriptor:dataT.list_descriptor[0].posicion,
            tipo_mensaje:"Jefe actualiza descriptor"
          }
        ]
      }
      await GeneralInfoServices.mailSendGeneralInfo(_data);
      toastr.success(messages.correoEnviado, '', {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_PREPARATION,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_PREPARATION,
        payload: false,
      });
    }
  };

  export const editIndispensablePreparation = (data, id, index) => async (dispatch, getState) => {
    try {
      // dispatch({
      //   type: actions.LOADING_PREPARATION,
      //   payload: true,
      // });
      const resp  =await PreparationServices.editPreparation(id, data);
      const { preparations, preparationsLength } = getState().preparation;
      const dataT = resp.data;
      preparations[index] = dataT;
      dispatch({
        type: actions.GET_PREPARATION,
        payload: {
          preparations: preparations,
          preparationsLength: preparationsLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL_PREPARATION,
        payload: "",
      });
      // setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      const _data = {
        data:[
          {
            funcion_descriptor:dataT.list_descriptor[0].posicion,
            tipo_mensaje:"Jefe actualiza descriptor"
          }
        ]
      }
      await GeneralInfoServices.mailSendGeneralInfo(_data);
      toastr.success(messages.correoEnviado, '', {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      // dispatch({
      //   type: actions.FORM_FAIL_PREPARATION,
      //   payload: message,
      // });
    } finally {
      // dispatch({
      //   type: actions.LOADING_PREPARATION,
      //   payload: false,
      // });
    }
  };

  export const editPreparationById = (data, id, setValidated) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_PREPARATION_BY_ID,
        payload: true,
      });
      const resp = await PreparationServices.editPreparation(id, data);
      const dataT = resp.data;
      dispatch({
        type: actions.GET_PREPARATION_BY_ID,
        payload: dataT,
      });
      // const { preparations, preparationsLength } = getState().preparation;
      // preparations[index] = resp.data;
      // dispatch({
      //   type: actions.GET_PREPARATION,
      //   payload: {
      //     preparations: preparations,
      //     preparationsLength: preparationsLength,
      //   },
      // });
      setValidated(false)
      dispatch({
        type: actions.FORM_FAIL_PREPARATION,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      const _data = {
        data:[
          {
            funcion_descriptor:dataT.list_descriptor[0].posicion,
            tipo_mensaje:"Jefe actualiza descriptor"
          }
        ]
      }
      await GeneralInfoServices.mailSendGeneralInfo(_data);
      toastr.success(messages.correoEnviado, '', {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_PREPARATION,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_PREPARATION_BY_ID,
        payload: false,
      });
    }
  };

export const deletePreparation = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_PREPARATION,
      payload: true,
    });
    await PreparationServices.deletePreparation(id);
    const { preparations, preparationsLength } = getState().preparation;
    preparations.splice(index, 1);
    dispatch({
      type: actions.GET_PREPARATION,
      payload: {
        preparations: preparations,
        preparationsLength: preparationsLength - 1,
      },
    });
    dispatch({
      type: actions.PREPARATION_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.PREPARATION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PREPARATION,
      payload: false,
    });
  }
};
